/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export default {
  command_intelligence_drawer_title: 'Command Intelligence',
  command_intelligence_drawer_resize_handle: 'Arrastra para cambiar el tamaño del panel',
  command_intelligence_close_aria: 'Cerrar asistente',
  command_intelligence_send_aria: 'Enviar mensaje',
  command_intelligence_stop_aria: 'Detener respuesta',
  command_intelligence_composer_input_aria: 'Mensaje para Command Intelligence',
  command_intelligence_drawer_more_options: 'Más opciones',
  command_intelligence_dock_position: 'Posición de acoplamiento',
  command_intelligence_dock_left: 'Izquierda',
  command_intelligence_dock_right: 'Derecha',
  command_intelligence_dock_top: 'Arriba',
  command_intelligence_dock_bottom: 'Abajo',
  command_intelligence_panel_layout: 'Diseño del panel',
  command_intelligence_panel_layout_overlap: 'Superponer contenido',
  command_intelligence_panel_layout_push: 'Desplazar contenido',
  command_intelligence_panel_auto_hide_overlap: 'Ocultar automáticamente al hacer clic fuera',
  command_intelligence_session_reset: 'Restablecer conversación',
  command_intelligence_try_one_of_these: 'Prueba una de estas',
  command_intelligence_attach_hint: 'Adjunta elementos de contexto para empezar a hacer preguntas.',
  command_intelligence_welcome_subhead: 'Haga una pregunta para comenzar.',
  command_intelligence_attach_modal_title: 'Adjuntar contexto',
  command_intelligence_attach_modal_subtitle:
    'Elige de los elementos en esta vista. Los elementos ya adjuntos aparecen atenuados.',
  command_intelligence_attach_modal_search_placeholder: 'Buscar…',
  command_intelligence_attach_modal_pool:
    '{count, plural, one {# elemento disponible} other {# elementos disponibles}} · {selected} seleccionados',
  command_intelligence_attach_modal_empty: 'No hay nada disponible para adjuntar',
  command_intelligence_attach_modal_no_results: 'Ningún elemento coincide con tu búsqueda',
  command_intelligence_context_bar_attached_section: 'Adjuntos ({count})',
  command_intelligence_context_bar_clear_attached: 'Borrar',
  command_intelligence_context_bar_add: 'Adjuntar contexto',
  command_intelligence_placeholder_ready: 'Haz una pregunta…',
  command_intelligence_placeholder_attach: 'Adjunta contexto para hacer una pregunta…',
  command_intelligence_composer_submit_hint: 'Enter para enviar · Mayús+Enter para nueva línea',
  command_intelligence_composer_stop_hint: 'Detener · redacta tu siguiente mensaje mientras esperas',
  command_intelligence_response_stopped: 'Respuesta detenida',
  command_intelligence_generation_in_progress: 'Trabajando en tu pregunta',
  command_intelligence_generation_trace_title: 'Pasos realizados',
  command_intelligence_generation_trace_toggle: 'Mostrar pasos',
  command_intelligence_generation_trace_summary: '{completed} de {total} pasos completados',
  command_intelligence_generation_trace_summary_generic: 'Pasos de generación',
  command_intelligence_generation_tool_count: '{count, plural, one {# herramienta} other {# herramientas}}',
  command_intelligence_generation_turn_label: 'Turno {turn} de {total}',
  command_intelligence_generation_turn_completed: 'Turno {turn} de {total} completado',
  command_intelligence_generation_turn_completed_elapsed:
    'Turno {turn} de {total} completado ({seconds}s transcurridos)',
  command_intelligence_generation_turn_completed_with_tools: 'Turno {turn} de {total} completado: usó {tools}',
  command_intelligence_generation_tools_used: 'Usó {tools}',
  command_intelligence_reasoning_thinking: 'Pensando…',
  command_intelligence_reasoning_thought_for_seconds: 'Pensó durante {seconds} segundos',
  command_intelligence_reasoning_waiting: 'Trabajando en tu pregunta…',
  command_intelligence_attach_modal_done: 'Listo',
  command_intelligence_attach_modal_attached_badge: 'adjunto',
  command_intelligence_attach_modal_attach: 'Adjuntar',
  command_intelligence_attach_modal_attach_count: 'Adjuntar ({count})',
  command_intelligence_attach_modal_close_aria: 'Cerrar selector',
  command_intelligence_session_limit_context:
    'Límite de contexto alcanzado. Restablece la conversación para continuar.',
  command_intelligence_session_limit_prompt: 'Límite de mensajes alcanzado. Restablece la conversación para continuar.',
  command_intelligence_suggested_followups: 'Seguimientos sugeridos',
  command_intelligence_credit_warning_line: '{pct}% de los créditos de IA mensuales de {scope} utilizados',
  command_intelligence_tooltip_prompts: '{count} de {max} mensajes ({pct}%)',
  command_intelligence_tooltip_context: '{used} de {max} tokens de contexto ({pct}%)',
  command_intelligence_tooltip_context_idle: 'El uso de contexto aparece después de la primera respuesta',
  command_intelligence_credits_loading: 'Cargando créditos…',
  command_intelligence_credits_unavailable: 'Créditos no disponibles',
  command_intelligence_credits_tooltip: 'Créditos de IA mensuales para {monthKey}',
  command_intelligence_credits_tooltip_short: 'Créditos de IA mensuales',
  command_intelligence_credits_scope_profile: 'Perfil',
  command_intelligence_credits_scope_entity: 'Entidad',
  command_intelligence_credits_used_of_cap: '{used} de {cap} créditos',
  command_intelligence_credits_used_no_cap: '{used} créditos utilizados',
  command_intelligence_credits_monthly_title: 'Créditos de IA mensuales',
  command_intelligence_compare_aria: 'Comparar agentes',
  command_intelligence_compare_tooltip: 'Ejecutar la misma pregunta con varios perfiles de agente',
  command_intelligence_compare_cancelled: 'Comparación cancelada',
  command_intelligence_compare_branch_failed: 'Rama de comparación fallida',
  command_intelligence_compare_title: 'Comparación de agentes',
  command_intelligence_compare_stats: '{durationMs} ms · {model} · {inTok} entrada / {outTok} salida · {agentRef}',
  command_intelligence_compare_error: '{message}',
  command_intelligence_profile_agent: '{agentRef}',
  command_intelligence_feedback_good_response: 'Buena respuesta',
  command_intelligence_feedback_bad_response: 'Mala respuesta',
  command_intelligence_feedback_dialog_title: 'Enviar comentarios',
  command_intelligence_feedback_dialog_body:
    'Ayúdanos a mejorar enviando comentarios sobre esta respuesta. Tus comentarios se enviarán a nuestro equipo de operaciones.',
  command_intelligence_feedback_response_label: 'Respuesta',
  command_intelligence_feedback_input_label: 'Tus comentarios (opcional)',
  command_intelligence_feedback_input_placeholder: '¿Qué estuvo mal o no fue útil en esta respuesta?',
  command_intelligence_feedback_submit: 'Enviar comentarios',
  command_intelligence_feedback_submit_error: 'No se pudieron enviar los comentarios. Inténtalo de nuevo.',
  command_intelligence_feedback_question_understanding: '¿El agente entendió lo que querías?',
  command_intelligence_feedback_question_readability: '¿La respuesta fue fácil de leer y usar?',
  command_intelligence_feedback_section_understanding: 'Comprensión',
  command_intelligence_feedback_section_readability: 'Legibilidad',
  command_intelligence_feedback_choice_none: 'Ninguno',
  command_intelligence_feedback_choice_misunderstood_task: 'Tarea mal entendida',
  command_intelligence_feedback_choice_ignored_constraint: 'Restricción ignorada',
  command_intelligence_feedback_choice_wrong_scope: 'Alcance incorrecto',
  command_intelligence_feedback_choice_visually_hard_to_read: 'Difícil de leer visualmente',
  command_intelligence_feedback_choice_wrote_too_much: 'Escribió demasiado',
  command_intelligence_feedback_choice_explanation_not_trustworthy: 'Explicación poco confiable',
  command_intelligence_copy_aria: 'Copiar al portapapeles',
  command_intelligence_error_missing_invoke_permission:
    'No tienes permiso para usar Command Intelligence con este agente. Pide a tu administrador que conceda los permisos de Intelligence necesarios (por ejemplo, analista).',
  command_intelligence_access_denied_title: 'Acceso requerido',
  command_intelligence_error_session_expired: 'Tu sesión ha expirado. Actualiza la página e inicia sesión de nuevo.',
};
